export default "__VITE_ASSET__99593cd8__"